// extracted by mini-css-extract-plugin
module.exports = {"container":"About-module--container--1KOCe","text":"About-module--text--3ozIx","title":"About-module--title--2_n_d","picture":"About-module--picture--2jGrj"};